// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { updateCustomField } from 'utils/proposals'

// Atoms
import TextInput from 'atoms/TextInput'
import Spacer from 'atoms/Spacer'
import FieldLayout from '../FieldLayout'

export default class ProposalLongTextEditor extends Component {
  static propTypes = {
    field: PropTypes.object.isRequired,
    normalizedFields: PropTypes.array.isRequired,
    onProposalUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
  }

  handleSave = (data) => {
    const { field, normalizedFields, onProposalUpdate } = this.props
    onProposalUpdate({
      data: {
        fields: updateCustomField(normalizedFields, field.key, data)
      }
    })
  }

  handleLabelSave = (label) => {
    this.handleSave({ label })
  }

  handlePlaceholderSave = (placeholder) => {
    this.handleSave({ placeholder })
  }

  handleDelete = () => {
    const { onDelete } = this.props
    onDelete()
  }

  render() {
    const { field } = this.props
    return (
      <Fragment>
        <Spacer />
        <FieldLayout title="Long text" onDelete={this.handleDelete}>
          <TextInput
            required
            maxLength={100}
            multiline
            label="Heading"
            placeholder="Type your question here..."
            defaultValue={field.label || ''}
            onSave={this.handleLabelSave}
          />
          <Spacer small />
          <TextInput
            maxLength={100}
            multiline
            label="Instructions"
            placeholder="Enter instructions here (optional)"
            defaultValue={field.placeholder || ''}
            onSave={this.handlePlaceholderSave}
          />
        </FieldLayout>
      </Fragment>
    )
  }
}
